"use client"

import { useEffect } from "react"
import { create } from "zustand"

export enum TimezoneType {
  UTC = "UTC",
  LOCAL = "LOCAL",
}

/** Returns the IANA timezone string (e.g. "UTC" or "America/Los_Angeles") for the given TimezoneType */
export function getIANATimezone(timezone: TimezoneType): string {
  if (timezone === TimezoneType.UTC) return "UTC"
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export interface TimezoneState {
  timezone: TimezoneType
  setTimezone: (timezone: TimezoneType) => void
}

export const useTimezoneStore = create<TimezoneState>((set) => ({
  timezone: TimezoneType.UTC,
  setTimezone: (timezone: TimezoneType) => set({ timezone }),
}))

export function TimezoneSyncer() {
  const timezone = useTimezoneStore((state) => state.timezone)
  const setTimezone = useTimezoneStore((state) => state.setTimezone)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedTimezone = localStorage.getItem("timezone")
      if (storedTimezone && storedTimezone !== timezone) {
        setTimezone(storedTimezone as TimezoneType)
      }
    }
  }, [setTimezone])

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("timezone", timezone)
    }
  }, [timezone])

  return null
}
